import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import FullScreenLoader from "@/components/FullScreenLoader";
import { Printer, Mail } from "lucide-react";

function renderContent(text) {
  return text.split("\n\n").map((block, i) => {
    if (block.startsWith("## ")) {
      const nl = block.indexOf("\n");
      const heading = (nl === -1 ? block : block.slice(0, nl)).replace("## ", "");
      const rest = nl === -1 ? "" : block.slice(nl + 1);
      return (
        <div key={i}>
          <h2 className="text-lg sm:text-xl font-bold mt-8 mb-2 tracking-tight">{heading}</h2>
          {rest && <p className="text-[15px] leading-relaxed text-foreground/80 mb-4 whitespace-pre-wrap">{rest}</p>}
        </div>
      );
    }
    return <p key={i} className="text-[15px] leading-relaxed text-foreground/80 mb-4 whitespace-pre-wrap">{block}</p>;
  });
}

export function LegalDocument({ docType, embedded = false }) {
  const { docType: paramType } = useParams();
  const type = docType || paramType;
  const [doc, setDoc] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setDoc(null); setNotFound(false);
    api.get(`/legal/documents/${type}`)
      .then((r) => { setDoc(r.data); window.scrollTo(0, 0); })
      .catch(() => setNotFound(true));
  }, [type]);

  if (notFound) return <div className="max-w-3xl mx-auto px-6 py-20 text-center"><h1 className="text-2xl font-bold">Document not found</h1></div>;
  if (!doc) return <FullScreenLoader />;

  const body = (
    <article className="max-w-3xl mx-auto" data-testid={`legal-doc-${type}`}>
      <div className="flex items-start justify-between gap-4 mb-2">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">{doc.title}</h1>
        <Button variant="outline" size="sm" onClick={() => window.print()} className="rounded-lg print:hidden shrink-0" data-testid="print-btn"><Printer className="h-4 w-4 mr-1.5" /> Print</Button>
      </div>
      <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm text-muted-foreground mb-8 border-b border-border pb-6">
        <span>Effective Date: <strong className="text-foreground/70">{doc.effective_date}</strong></span>
        {doc.last_updated && <span>Last Updated: <strong className="text-foreground/70">{new Date(doc.last_updated).toLocaleDateString()}</strong></span>}
        <span>Version {doc.version}</span>
      </div>
      <div>{renderContent(doc.content)}</div>
      <div className="mt-10 pt-6 border-t border-border flex items-center gap-2 text-sm text-muted-foreground">
        <Mail className="h-4 w-4" /> Questions? Contact <a href="mailto:admin@drelik.com" className="text-primary font-medium hover:underline">admin@drelik.com</a>
      </div>
    </article>
  );

  if (embedded) return body;
  return <div className="min-h-screen bg-background px-6 py-12 sm:py-16">{body}</div>;
}

export default LegalDocument;
